import LocatorVerify from './locator.vue'
import DeliveryCode from './delivery-code.vue'
import Completed from './completed.vue'
import ConfirmationEntrega from './index.vue'

const routes = [
  {
    path: '/confirmation-entrega',
    name: 'confirmationEntrega',
    component: ConfirmationEntrega,
  },
  {
    path: '/confirmation-entrega/locator',
    name: 'locatorVerify',
    component: LocatorVerify,
  },
  {
    path: '/confirmation-entrega/delivery-code',
    name: 'deliveryCode',
    component: DeliveryCode,
  },
  {
    path: '/confirmation-entrega/completed',
    name: 'completed',
    component: Completed,
  },
]

export default routes
